import {getAllProductsObject, getSingleProductById} from "../Products/functions";
import {Fragment} from "react";
import {getManagerHeader} from "../Login/functions";
import axios from "axios";
import {baseCmsApiUrl} from "../../assets/Constants";
import {base64DecodeUnicode} from "../../assets/functions";

export const getAllOrders = async (queryString = "") => {
    const headers = getManagerHeader();
    return axios.get(baseCmsApiUrl + 'bills' + queryString, {headers})
        .then((response) => {
            // console.log(response)
            // console.log(base64DecodeUnicode(response.statusText))
            return response.data;
        })
        .catch((e) => {
            console.error(e)
            console.log(base64DecodeUnicode(e.response.statusText))
            console.log(e.response.data)
        })
}
export const getOrderById = async (id) => {
    const headers = getManagerHeader();
    return axios.get(baseCmsApiUrl + 'bills?id=' + id, {headers})
        .then((response) => {
            // console.log(response)
            // console.log(base64DecodeUnicode(response.statusText))
            return response.data;
        })
        .catch((e) => {
            console.error(e)
            console.log(base64DecodeUnicode(e.response.statusText))
            console.log(e.response.data)
        })
}
export const getProductWithSingleProduct = async (queryString = "") => {
    const allProducts = await getAllProductsObject(queryString);

    return allProducts;
}

export const getSingleProductPersianTitleById = async (id) => {
    const singleProduct = await getSingleProductById(id);
    return singleProduct.persianTitle;
}

export const printUnitPriceForBill = (price, calculateInTomanRate = false) => {
    let amountText = "";
    let discountAmountText = "";
    if (price.discountAmount)
        discountAmountText += price.discountAmount.toLocaleString();

    if (price.amount)
        amountText += price.amount.toLocaleString();

    if (discountAmountText) {
        return (
            <Fragment>
                <span className={"small text-danger text-decoration-line-through d-block mb-2"}>{amountText}</span>
                <span>{discountAmountText}</span>
            </Fragment>
        );
    }

    return (<span>{amountText}</span>);

}

export const getUnitPrice = (price, calculateInTomanRate = false) => {
    if (price.discountAmount)
        return price.discountAmount

    return price.amount;

}

export const getBillAmountWithoutDiscount = (billItems) => {
    let amount = 0;

    for (let i = 0; i < billItems.length; i++) {
        const price = billItems[i].price;
        if (billItems[i].payType == "CASH") {
            amount += parseInt(billItems[i].count) * parseFloat(price.amount) * parseFloat(billItems[i].price.currency.rate);
        } else if (billItems[i].payType == "INSTALLMENT") {
            amount += parseInt(billItems[i].prepayedAmount);
            for (let j = 0; j < billItems[i].installmentHistories.length; j++) {
                amount += parseInt(billItems[i].installmentHistories[j].amount);
            }
        }
    }

    return amount;
}

export const getBillDiscountAmount = (billItems) => {
    let amount = 0;

    for (let i = 0; i < billItems.length; i++) {
        const price = billItems[i].price;
        if (price.discountAmount) {
            amount += parseInt(billItems[i].count) * (parseFloat(price.amount) - parseFloat(price.discountAmount)) * parseFloat(billItems[i].price.currency.rate);
        }

    }

    return amount;
}

export const getBillPayableAmount = (bill) => {
    return getBillAmountWithoutDiscount(bill.billItems) + parseInt(bill.deliveryAmount ? bill.deliveryAmount : 0 ) - getBillDiscountAmount(bill.billItems) - parseInt(bill.discountAmountWithDiscountCode);
}

export const getPayedInstallmentHistoryAmount = (installmentHistories) => {
    let amount = 0;
    for (let i = 0; i < installmentHistories.length; i++) {
        if (installmentHistories[i].payedTimestamp) {
            amount += installmentHistories[i].amount;
        }
    }
    return amount;
}
export const getBillPayedAmount = (bill) => {
    let amount = 0;

    if (bill.isPayed) {
        amount += bill.deliveryAmount ? bill.deliveryAmount : 0;
    }

    for (let i = 0; i < bill.billItems.length; i++) {
        const price = bill.billItems[i].price;
        if (bill.billItems[i].payType == "CASH") {
            if (bill.billItems[i].isPayed) {
                amount += parseInt(bill.billItems[i].count) * parseFloat(getUnitPrice(price)) * parseFloat(bill.billItems[i].price.currency.rate);
            }
        } else if (bill.billItems[i].payType == "INSTALLMENT") {
            if (bill.billItems[i].isPayed) {
                amount += parseInt(bill.billItems[i].prepayedAmount);
            }
            amount += getPayedInstallmentHistoryAmount(bill.billItems[i].installmentHistories)

        }


    }
    amount -= bill.discountAmountWithDiscountCode;
    return amount < 0 ? 0 : amount;
}


